module.exports = __webpack_public_path__ + "img/Farm_3.5ee86494.jpg";